import enUS from '../locales/en-US.json';
import ptBR from '../locales/pt-BR.json';
import type { Locale, TranslationCatalog } from './types.js';

export const defaultLocale: Locale = 'pt-BR';
export const fallbackLocale: Locale = 'en-US';

export const catalogs = {
  'en-US': enUS,
  'pt-BR': ptBR,
} satisfies Record<Locale, TranslationCatalog>;
